import React from 'react';
import { Helmet } from 'react-helmet-async';
import ContactForm from '../components/ContactForm/ContactForm';
import styles from './Contacts.module.css';

export default function Contacts() {
  return (
    <>
      <Helmet>
        <title>Контакты — ООО Советник | Связаться с нами</title>
        <meta name="description" content="Свяжитесь с ООО Советник для бесплатной консультации по ВЭД. Тверь, пер. Спортивный, д.1А, оф.9. Телефон: +7 (910) 936-98-89. Email: info@konsultant-sovetnik.ru" />
        <link rel="canonical" href="https://konsultant-sovetnik.ru/contacts" />
        <meta property="og:title" content="Контакты — ООО Советник" />
        <meta property="og:description" content="Свяжитесь с нами для бесплатной консультации по ВЭД." />
        <meta property="og:url" content="https://konsultant-sovetnik.ru/contacts" />
        <meta property="og:image" content="https://konsultant-sovetnik.ru/logo512.png" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ContactPage",
          "name": "Контакты — ООО Советник",
          "url": "https://konsultant-sovetnik.ru/contacts",
          "mainEntity": {
            "@type": "Organization",
            "name": "ООО Советник",
            "email": "info@konsultant-sovetnik.ru",
            "telephone": "+7-910-936-98-89",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "пер. Спортивный, д.1А, оф.9",
              "addressLocality": "Тверь",
              "addressCountry": "RU"
            }
          }
        })}</script>
      </Helmet>
      <section className={styles.hero}>
        <div className={styles.container}>
          <span className={styles.badge}>Контакты</span>
          <h1 className={styles.title}>Свяжитесь с нами</h1>
          <p className={styles.subtitle}>
            Мы всегда готовы ответить на ваши вопросы и предложить оптимальное решение
          </p>
        </div>
      </section>

      <section className={styles.section}>
        <div className={styles.container}>
          <div className={styles.infoGrid}>
            <div className={styles.infoCard}>
              <span className={styles.infoIcon}>✉️</span>
              <h3>Email</h3>
              <p><a href="mailto:info@konsultant-sovetnik.ru">info@konsultant-sovetnik.ru</a></p>
            </div>
            <div className={styles.infoCard}>
              <span className={styles.infoIcon}>📞</span>
              <h3>Телефон</h3>
              <p><a href="tel:+79109369889">+7 (910) 936-98-89</a></p>
            </div>
            <div className={styles.infoCard}>
              <span className={styles.infoIcon}>🕐</span>
              <h3>Часы работы</h3>
              <p>Пн — Пт: 9:00 — 18:00</p>
            </div>
          </div>

          <div className={styles.leadership}>
            <h2 className={styles.leadershipTitle}>Прямая связь с руководством</h2>
            <p className={styles.leadershipSubtitle}>
              Для оперативных вопросов и предложений о сотрудничестве
            </p>
            <div className={styles.personGrid}>
              <a href="mailto:ceo@konsultant-sovetnik.ru" className={styles.personCard}>
                <span className={styles.personRole}>Исполнительный директор</span>
                <span className={styles.personEmail}>ceo@konsultant-sovetnik.ru</span>
              </a>
              <a href="mailto:cco@konsultant-sovetnik.ru" className={styles.personCard}>
                <span className={styles.personRole}>Коммерческий директор</span>
                <span className={styles.personEmail}>cco@konsultant-sovetnik.ru</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <ContactForm type="consultation" />
    </>
  );
}
